import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'start',
    position: 'relative',
    zIndex: 2,
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    cursor: 'pointer',
  },
  headerName: {
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '15px',
    color: '#2C2D3E',
    width: '100%',
    padding: '12px',
    margin: '0px',
  },
  headerScore: {
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '15px',
    color: '#2C2D3E',
    padding: '12px',
    margin: '0px',
  },
  summary: {
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '15px',
    color: '#2C2D3E',
    padding: '12px 12px 12px 20px',
    margin: '0px',
  },
  scoreList: {
    listStyle: 'none',
    margin: '0px',
    paddingLeft: '0px',
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '14px',
    color: '#2C2D3E',
    width: '100%',
    '& li': {
      margin: '12px 12px 10px 26px',
      justifyContent: 'space-between',
      cursor: 'pointer',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      display: '-webkit-box',
      '-webkit-line-clamp': 2,
      '-webkit-box-orient': 'vertical',
    },
  },
  taskScore: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
  },
  rowWithQualityPill: {
    backgroundColor: '#D6D6FB',
    marginBottom: '5px',
  },
  score: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'start',
    alignItems: 'start',
    position: 'relative',
    width: '100%',
    zIndex: 2,
  },
  sampleAssessmentScoreContainer: {
    display: 'flex',
    alignItems: 'center',
  },
}));
